import Handler from "@/core/domain/usecase/handler";

const deleteServiceOrderRepository = (axios) => async (id) => {
    try {
        const response = await axios.delete(`/service-order/${id}`)
        return response.data
    } catch (error) {
        if(error.isAxiosError) {
            throw new Handler().trataErro(error)
        } else {
            throw error
        }
    }
}

export default deleteServiceOrderRepository